import * as React from "react";
import { Container, Paper, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "../../common/seo";

const PATH = "/copyright";

export function CopyrightPage() {
  const title = "Copyright & DMCA | NWA Blog";
  const description =
    "Copyright information and a simple DMCA/contact path for content removal requests.";

  return (
    <Container component="section" sx={{ marginTop: "5rem" }}>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonicalUrl(PATH)} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl(PATH)} />
      </Helmet>

      <Paper elevation={1} sx={{ padding: "1rem" }}>
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Copyright & DMCA
        </Typography>

        <Typography
          variant="body2"
          sx={{ marginTop: "1rem", whiteSpace: "pre-line" }}
        >
          {`This site contains original writing and photography unless otherwise credited.

If you believe content on this site infringes your copyright, please contact the site owner with:
- The URL(s) of the content in question
- A description of the copyrighted work
- Your contact information
- A statement that you have a good-faith belief the use is not authorized

We’ll review and, if appropriate, remove or attribute the material promptly.`}
        </Typography>
      </Paper>
    </Container>
  );
}
